export const SPLIT_BILL_TEST_IDS = {
    WIDGET: "split-bill-widget",
    FORM: "split-bill-form",
    SPLIT_EQUALLY: "split-bill-split-equally",
    ADD_GUESTS: "split-bill-add-guests",
    CONFIRM_BTN: "split-bill-confirm-btn",
    TAB_AMOUNT: "split-bill-tab-amount",
    TAB_SHARE: "split-bill-tab-share",
    TAB_PERCENTAGE: "split-bill-tab-percentage",
    AMOUNT_INPUT: "split-bill-amount-input",
    SHARE_CONTROL: "split-bill-share-control",
    UPI_STEP: "split-bill-upi-step",
    UPI_INPUT: "split-bill-upi-input",
    SEND_REQUEST: "split-bill-send-request",
    STATUS: "split-bill-status",
    STATUS_CTA: "split-bill-status-cta",
    WARNING_CALLOUT: "split-bill-warning-callout",
    DINECASH_ROW: "split-bill-dinecash-row",
    DINECASH_INFO_ICON: "split-bill-dinecash-info-icon",
    DINECASH_DLS_TOOLTIP: "split-bill-dinecash-dls-tooltip",
    TITLE_BADGE: "split-bill-title-badge",
    CTA: "split-bill-cta",
};
